export type DatasetMode = 'cases' | 'slides' | 'needsAssignment';

export const getDatasetMode = ({
  slidesMode,
  pendingSlidesMode,
}: {
  slidesMode?: boolean | null;
  pendingSlidesMode?: boolean | null;
}): DatasetMode => (pendingSlidesMode ? 'needsAssignment' : slidesMode ? 'slides' : 'cases');

export const getDatasetModeQueryParams = (mode: DatasetMode) => ({
  slidesMode: mode !== 'cases',
  pendingSlidesMode: mode === 'needsAssignment',
  page: 1,
});
